// extracted by mini-css-extract-plugin
module.exports =  {"templateTitle":"templateTitle_NH1AyO2k"};